"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPaginatorV2Constants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BC_PAGINATOR_V2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-paginator-v2");
var BC_PAGINATOR_V2_CONSTANTS_NUMBERS = {
    N576: 576,
    N768: 768,
    N992: 992,
};
var BcPaginatorV2Constants = (function () {
    function BcPaginatorV2Constants() {
    }
    BcPaginatorV2Constants.BC_PAGINATOR_V2 = BC_PAGINATOR_V2;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_LINK = "".concat(BC_PAGINATOR_V2, "-prev-link");
    BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_LINK = "".concat(BC_PAGINATOR_V2, "-next-link");
    BcPaginatorV2Constants.BC_PAGINATOR_V2_TYPE_BASIC = 'basic';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_TYPE_NUMERIC = 'numeric';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_RECORDS_PER_PAGE = common_constants_1.COMMON_CONSTANTS_NUMBERS.N10;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_ARIA_LABEL = 'Paginador';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_TEXT = 'Anterior';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_TEXT = 'Siguiente';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_ARIA_LABEL = 'Página anterior';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_ARIA_LABEL = 'Página siguiente';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_SECOND_PAGE = common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_ONCHANGEPAGE_ERROR = 'Evento onChangePage no esta definido';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_NUM_PAGES_WITHOUT_ELLIPSIS = common_constants_1.COMMON_CONSTANTS_NUMBERS.N7;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_NUM_PAGES_WITHOUT_ELLIPSIS_MOBILE = common_constants_1.COMMON_CONSTANTS_NUMBERS.N5;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGE_LINKS_ARIA_LABEL = 'Página # ';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_BUTTON_ARIA_LABEL = 'Ir a la página anterior';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_BUTTON_ARIA_LABEL = 'Ir a la página siguiente';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PREV_BUTTON = "".concat(BC_PAGINATOR_V2, "-prev-button");
    BcPaginatorV2Constants.BC_PAGINATOR_V2_NEXT_BUTTON = "".concat(BC_PAGINATOR_V2, "-next-button");
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGE_INDEX_100 = common_constants_1.COMMON_CONSTANTS_NUMBERS.N100;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_MAX_OPTIONS_ITEMS_PER_PAGE = common_constants_1.COMMON_CONSTANTS_NUMBERS.N5;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_COMPLETE_TEXT_INFO_ITEMS = "Mostrando [startIndex]-[endIndex] de [totalItems] [textElements]";
    BcPaginatorV2Constants.BC_PAGINATOR_V2_CUSTOM_TEXT_INFO_ITEMS = 'elementos';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_INPUT_SELECT_ARIA_LABEL = 'Cantidad de elementos a mostrar por página';
    BcPaginatorV2Constants.BC_PAGINATOR_V2_TEXT_INFO = "".concat(BC_PAGINATOR_V2, "-text-info");
    BcPaginatorV2Constants.BC_PAGINATOR_V2_SM_MOBILE = BC_PAGINATOR_V2_CONSTANTS_NUMBERS.N576;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_MD_TABLET = BC_PAGINATOR_V2_CONSTANTS_NUMBERS.N768;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_LG_DESKTOP = BC_PAGINATOR_V2_CONSTANTS_NUMBERS.N992;
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGES_CONTAINER = "".concat(BC_PAGINATOR_V2, "-pages-links");
    BcPaginatorV2Constants.BC_PAGINATOR_V2_PAGES_ARIA_LABEL = 'Páginas de navegación';
    return BcPaginatorV2Constants;
}());
exports.BcPaginatorV2Constants = BcPaginatorV2Constants;
